var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage041(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #234492;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.03,55c-7.76,0-15.52,0-23.27-.01-.43,0-.89-.07-1.27-.25-.68-.32-.98-1.06-.86-1.82,.11-.66,.66-1.24,1.34-1.39,.25-.05,.51-.07,.77-.07,15.52,0,31.03,0,46.55,0,1.34,0,2.16,.72,2.13,1.85-.03,.88-.72,1.61-1.6,1.68-.22,.02-.44,.01-.66,.01-7.7,0-15.41,0-23.11,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.75,26.52c-5.54,5.51-11.07,11.03-16.59,16.59-.57,.57-1.14,1.15-1.71,1.72-1.25,1.26-2.58,2.04-4.39,2.1-1.97,.09-3.94,.36-5.65,.52-2.21,.06-3.6-1.32-3.45-3.25,.18-2.39,.38-4.78,.68-7.16,.09-.68,.53-1.32,.85-1.95,.1-.21,.31-.37,.48-.53,6.3-6.32,12.6-12.62,18.91-18.91l10.87,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.68,14.6c.08,1.64-.48,3.29-1.68,4.6-.84,.93-1.76,1.8-2.64,2.7-.54,.54-1.07,1.07-1.61,1.62l-10.87-10.87c1.29-1.3,2.58-2.59,3.87-3.88,2.66-2.66,6.78-2.67,9.45-.05,.6,.6,1.22,1.19,1.79,1.82,1.06,1.18,1.63,2.61,1.69,4.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage041);
export default __webpack_public_path__ + "static/media/UDS Needs Image-04 (1).689c55a444f310c5000b8e4e87079ffd.svg";
export { ForwardRef as ReactComponent };